import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "opModal" }
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", null, "Prodotti acquistati", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cart_item = _resolveComponent("cart-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offers, (item, i) => {
        return (_openBlock(), _createBlock(_component_cart_item, {
          "cart-item": item,
          key: i
        }, null, 8, ["cart-item"]))
      }), 128))
    ])
  ]))
}